export default String.raw`
.card-product {
    &__image {
        height: 234px;
    }
}
`